import { useQuery } from '@tanstack/react-query';
import { PRODUCT_TYPE } from 'src/constants/queryKeys';
import axiosInstance from 'src/utils/axios';

export const networkGetProductType = async () => {
  const res = await axiosInstance.post('ApplicationType/List');
  return res;
};

export function useFetchProductType() {
  return useQuery({
    queryKey: [PRODUCT_TYPE],
    queryFn: () => networkGetProductType(),
  });
}

export const networkUpdateProductType = async (id, payload) => {
  const res = await axiosInstance.post(`ApplicationType/Update/${id}`, payload);
  return res;
};

export const networkInsertProductType = async (payload) => {
  const res = await axiosInstance.post(`ApplicationType/Insert`, payload);
  return res;
};
